import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';

export const callDealsPreLoginGetApi = async (payload) => {
  const {
    pageNumber,
    pageSize,
    sectionId,
    filters,
    extraParams = {},
    extraHeaders = {}
  } = payload;
  let finalFilter
  // Improved filter mapping: only include non-empty filter arrays
  const filterKeys = ['brand', 'category', 'validity', 'offer'];
  finalFilter = {};
  filterKeys.forEach(key => {
    if (Array.isArray(filters?.[key]) && filters[key].length > 0) {
      // Capitalize key for API contract
      const apiKey = key.charAt(0).toUpperCase() + key.slice(1);
      finalFilter[apiKey] = filters[key].map(item => item);
    }
  });

  // If no filters are present, set finalFilter to undefined
  if (Object.keys(finalFilter).length === 0) {
    finalFilter = undefined;
  }

  let params;
  if (finalFilter) {
    params = {
      pageNumber,
      pageSize,
      ...finalFilter,
      ...(sectionId && { sectionId }),
      ...extraParams,
    };
  } else {
    params = {
      pageNumber,
      pageSize,
      ...(sectionId && { sectionId }),
      ...extraParams
    };
  }

  // Convert array values in params to comma-separated strings
  Object.keys(params).forEach(key => {
    if (Array.isArray(params[key])) {
      params[key] = params[key].join(',');
    }
  });

  
  let headers = {
    ...extraHeaders
  };


  const { data = {} } = await axiosInstanceClient.get(API.dealsPreLogin,{
      params,
      headers
    }
  );
  return data;
};


